import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Icon,
  Checkbox,
  Radio,
  Input,
  Button,
  Form,
  FormGroup,
  FormField,
  TextArea
} from 'semantic-ui-react'

const CardSummaryPlanningUX = (props: any) => {
    return(
      <div
        id="CardSummaryPlanningUX-div-0"
        style={{padding: "10px"}}>
        <div
          id="CardSummaryPlanningUX-div-88"
          style={{display: "flex", justifyContent: "space-between"}}>
          
          <div
            id="CardSummaryPlanningUX-div-97"
            style={{display: "flex", alignItems: "center"}}>
            
            <div
              className="ui label pink ribbon"
              id="CardSummaryPlanningUX-div-99">
              {props.languageUX === "en" ? "NURSING DISCHARGE PLANNING SUMMARY" : "สรุปการวางแผนการจำหน่ายพยาบาล"}
            </div>
          </div>
          <div
            id="CardSummaryPlanningUX-div-98"
            style={{display: "flex"}}>
            
            <Label
              color="pink"
              id="CardSummaryPlanningUX-Label-101"
              style={{display: props.showStatus ? "" : "none"}}>
              {props.languageUX === "en" ? "Draft" : "ร่าง"}
            </Label>
            <div
              id="CardSummaryPlanningUX-div-102"
              style={{cursor: "pointer", margin: "-5px -5px 0 15px", display: props.closeIcon ? "" : "none"}}>
              
              <Icon
                className="red large"
                id="CardSummaryPlanningUX-Icon-103"
                name={"close"}
                onClick={props.onClose}>
              </Icon>
            </div>
          </div>
        </div>
        <div
          id="CardSummaryPlanningUX-div-104"
          style={{paddingTop:"10px"}}>
          
          <div
            id="CardSummaryPlanningUX-div-105"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(6, 1fr)","gridTemplateColumns":"repeat(50, 1fr)"}}>
            <div
              id="CardSummaryPlanningUX-div-108"
              style={{ gridRow: "1/2", gridColumn: "1/15",fontWeight: "bold"}}>
              {`1. ${props.ClinicalTermNursing?.disc_nursing1?.name}`}
            </div>
            <div
              id="CardSummaryPlanningUX-div-109"
              style={{ gridRow: "2/3", gridColumn: "1/15",fontWeight: "bold"}}>
              
              <Label
                id="CardSummaryPlanningUX-Label-112">
                {props.dischargePlanning?.predischarge_condition || '-'}
              </Label>
            </div>
            <div
              id="CardSummaryPlanningUX-div-110"
              style={{ gridRow: "3/4", gridColumn: "1/15",fontWeight: "bold"}}>
              {`2. ${props.ClinicalTermNursing?.disc_nursing2?.name}`}
            </div>
            <div
              id="CardSummaryPlanningUX-div-115"
              style={{ gridRow: "3/4", gridColumn: "17/23",display:"flex"}}>
              
              <Radio
                checked={props.ClinicalTermNursing?.disc_nursing1?.has_problem === "N"}
                id="CardSummaryPlanningUX-Radio-116"
                label={props.languageUX === "en" ? "do not have" : "ไม่มี"}
                name="has_problem"
                onChange={props.handleChangeValue("disc_nursing1.has_problem")}
                style={{ marginRight: "20px" }}
                value="N">
              </Radio>
              <Radio
                checked={props.ClinicalTermNursing?.disc_nursing1?.has_problem === "Y"}
                id="CardSummaryPlanningUX-Radio-117"
                label={props.languageUX === "en" ? "have" : "มี"}
                name="has_problem"
                onChange={props.handleChangeValue("disc_nursing1.has_problem")}
                style={{ marginRight: "20px" }}
                value="Y">
              </Radio>
            </div>
            <div
              id="CardSummaryPlanningUX-div-111"
              style={{ gridRow: "4/5", gridColumn: "1/10",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing2?.items[0]?.checked}
                id="CardSummaryPlanningUX-Checkbox-113"
                onChange={props.handleCheckValue("disc_nursing2.items.0.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-114"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.ClinicalTermNursing?.disc_nursing2?.items[0]?.name}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-119"
              style={{ gridRow: "4/5", gridColumn: "11/16",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing2?.items[1]?.checked}
                id="CardSummaryPlanningUX-Checkbox-125"
                onChange={props.handleCheckValue("disc_nursing2.items.1.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-129"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.ClinicalTermNursing?.disc_nursing2?.items[1]?.name}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-120"
              style={{ gridRow: "4/5", gridColumn: "17/25",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing2?.items[2]?.checked}
                id="CardSummaryPlanningUX-Checkbox-126"
                onChange={props.handleCheckValue("disc_nursing2.items.2.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-130"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.ClinicalTermNursing?.disc_nursing2?.items[2]?.name}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-121"
              style={{ gridRow: "4/5", gridColumn: "26/35",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing2?.items[3]?.checked}
                id="CardSummaryPlanningUX-Checkbox-127"
                onChange={props.handleCheckValue("disc_nursing2.items.3.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-131"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.ClinicalTermNursing?.disc_nursing2?.items[3]?.name}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-118"
              style={{ gridRow: "6/7", gridColumn: "1/4",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing2?.items[4]?.checked}
                id="CardSummaryPlanningUX-Checkbox-124"
                onChange={props.handleCheckValue("disc_nursing2.items.4.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-128"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.languageUX === "en" ? "other" : "อื่น ๆ"}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-122"
              style={{ gridRow: "6/7", gridColumn: "5/6",}}>
              {props.languageUX === "en" ? "specify" : "ระบุ"}
            </div>
            <div
              id="CardSummaryPlanningUX-div-123"
              style={{ gridRow: "6/7", gridColumn: "7/16",}}>
              
              <Input
                id="CardSummaryPlanningUX-Input-132"
                onChange={props.handleChangeValue("disc_nursing2.items.4.answer")}
                type="text"
                value={props.ClinicalTermNursing?.disc_nursing2?.items[4]?.answer}>
              </Input>
            </div>
          </div>
          <div
            id="CardSummaryPlanningUX-div-173">
            
            <div
              id="CardSummaryPlanningUX-div-133"
              style={{ height:"40px", fontWeight: "bold"}}>
              {`3. ${props.ClinicalTermNursing?.disc_nursing3?.name}`}
            </div>
            <div
              id="CardSummaryPlanningUX-div-134"
              style={{ gridRow: "8/9", gridColumn: "2/10"}}>
              
              <div
                className="ui form"
                id="CardSummaryPlanningUX-div-171">
                {props.discNursing3}
              </div>
              <Button
                color="blue"
                id="CardSummaryPlanningUX-Button-135"
                onClick={props.onAddDiscNursing3}>
                {props.languageUX === "en" ? "increase" : "เพิ่ม"}
              </Button>
            </div>
          </div>
          <div
            id="CardSummaryPlanningUX-div-172"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(13, 1fr)","gridTemplateColumns":"repeat(50, 1fr)"}}>
            <div
              id="CardSummaryPlanningUX-div-136"
              style={{ gridRow: "1/2", gridColumn: "1/18",fontWeight: "bold"}}>
              {`4. ${props.ClinicalTermNursing?.disc_nursing4?.name}`}
            </div>
            <div
              id="CardSummaryPlanningUX-div-138"
              style={{ gridRow: "2/3", gridColumn: "1/8", display: "flex" }}>
              
              <div
                id="CardSummaryPlanningUX-div-137"
                style={{ fontWeight: "bold", padding: "5px" }}>
                {props.languageUX === "en" ? "date" : "วันที่"}
              </div>
              <Label
                id="CardSummaryPlanningUX-Label-142">
                {props.dischargePlanning?.ended_date || '-'}
              </Label>
            </div>
            <div
              id="CardSummaryPlanningUX-div-140"
              style={{ gridRow: "2/3", gridColumn: "9/15", display: "flex"}}>
              
              <div
                id="CardSummaryPlanningUX-div-139"
                style={{ fontWeight: "bold", padding: "5px" }}>
                {props.languageUX === "en" ? "time" : "เวลา"}
              </div>
              <Label
                id="CardSummaryPlanningUX-Label-143">
                {props.dischargePlanning?.ended_time || '-'}
              </Label>
            </div>
            <div
              id="CardSummaryPlanningUX-div-144"
              style={{ gridRow: "2/3", gridColumn: "16/30", display: "flex"}}>
              
              <div
                id="CardSummaryPlanningUX-div-141"
                style={{ fontWeight: "bold", padding: "5px" }}>
                {props.languageUX === "en" ? "From the ward" : "จากหอผู้ป่วย"}
              </div>
              <Label
                id="CardSummaryPlanningUX-Label-145">
                {props.dischargePlanning?.discharged_from || '-'}
              </Label>
            </div>
            <div
              id="CardSummaryPlanningUX-div-146"
              style={{ gridRow: "3/4", gridColumn: "1/18",fontWeight: "bold"}}>
              {`5. ${props.ClinicalTermNursing?.disc_nursing5?.name}`}
            </div>
            <div
              id="CardSummaryPlanningUX-div-147"
              style={{ gridRow: "4/8", gridColumn: "2/25"}}>
              
              <Form
                id="CardSummaryPlanningUX-Form-175">
                <FormGroup
                  id="CardSummaryPlanningUX-FormGroup-176"
                  inline={true}>
                  <FormField
                    id="CardSummaryPlanningUX-FormField-177"
                    inline={true}
                    width={16}>
                    <TextArea
                      id="CardSummaryPlanningUX-TextArea-178"
                      onChange={props.handleChangeValue("disc_nursing5.nextAppointments")}
                      rows={6}
                      style={{ width: "100%", height: "100%" }}
                      value={props.ClinicalTermNursing?.disc_nursing5?.nextAppointments}>
                    </TextArea>
                  </FormField>
                </FormGroup>
              </Form>
            </div>
            <div
              id="CardSummaryPlanningUX-div-149"
              style={{ gridRow: "9/10", gridColumn: "1/18",fontWeight: "bold"}}>
              {`6. ${props.ClinicalTermNursing?.disc_nursing6?.name}`}
            </div>
            <div
              id="CardSummaryPlanningUX-div-150"
              style={{ gridRow: "10/11", gridColumn: "1/5",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing6?.items[0]?.checked}
                id="CardSummaryPlanningUX-Checkbox-157"
                onChange={props.handleCheckValue("disc_nursing6.items.0.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-162"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.ClinicalTermNursing?.disc_nursing6?.items[0]?.name}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-151"
              style={{ gridRow: "10/11", gridColumn: "6/11",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing6?.items[1]?.checked}
                id="CardSummaryPlanningUX-Checkbox-158"
                onChange={props.handleCheckValue("disc_nursing6.items.1.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-163"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.ClinicalTermNursing?.disc_nursing6?.items[1]?.name}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-152"
              style={{ gridRow: "10/11", gridColumn: "12/18",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing6?.items[2]?.checked}
                id="CardSummaryPlanningUX-Checkbox-159"
                onChange={props.handleCheckValue("disc_nursing6.items.2.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-164"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.ClinicalTermNursing?.disc_nursing6?.items[2]?.name}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-153"
              style={{ gridRow: "10/11", gridColumn: "19/29",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing6?.items[3]?.checked}
                id="CardSummaryPlanningUX-Checkbox-160"
                onChange={props.handleCheckValue("disc_nursing6.items.3.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-165"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.ClinicalTermNursing?.disc_nursing6?.items[3]?.name}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-154"
              style={{ gridRow: "11/12", gridColumn: "1/4",display:"flex"}}>
              
              <Checkbox
                checked={props.ClinicalTermNursing?.disc_nursing6?.items[4]?.checked}
                id="CardSummaryPlanningUX-Checkbox-161"
                onChange={props.handleCheckValue("disc_nursing6.items.4.checked")}
                style={{marginTop:"5px"}}>
              </Checkbox>
              <div
                id="CardSummaryPlanningUX-div-166"
                style={{marginTop:"3px",marginLeft:"10px"}}>
                {props.ClinicalTermNursing?.disc_nursing6?.items[4]?.name}
              </div>
            </div>
            <div
              id="CardSummaryPlanningUX-div-155"
              style={{ gridRow: "11/12", gridColumn: "5/6",display:"flex"}}>
              {props.languageUX === "en" ? "specify" : "ระบุ"}
            </div>
            <div
              id="CardSummaryPlanningUX-div-156"
              style={{ gridRow: "11/12", gridColumn: "7/18",display:"flex"}}>
              
              <Input
                id="CardSummaryPlanningUX-Input-167"
                onChange={props.handleChangeValue("disc_nursing6.items.4.answer")}
                value={props.ClinicalTermNursing?.disc_nursing6?.items[4]?.answer}>
              </Input>
            </div>
            <div
              id="CardSummaryPlanningUX-div-168"
              style={{ gridRow: "12/13", gridColumn: "1/18",fontWeight: "bold"}}>
              {`7. ${props.ClinicalTermNursing?.disc_nursing7?.name}`}
            </div>
            <div
              id="CardSummaryPlanningUX-div-169"
              style={{ gridRow: "13/14", gridColumn: "2/19"}}>
              
              <Label
                id="CardSummaryPlanningUX-Label-170">
                {props.dischargePlanning?.discharge_status || '-'}
              </Label>
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardSummaryPlanningUX

export const screenPropsDefault = {"drugSearch":"[Drug Search Box]"}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "สรุปการวางแผนการจำหน่ายพยาบาล",
          "valueEN": "NURSING DISCHARGE PLANNING SUMMARY"
        },
        "className": {
          "type": "value",
          "value": "ui label pink ribbon"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-99"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "ร่าง",
          "valueEN": "Draft"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "pink"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Label-101"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: props.showStatus ? \"\" : \"none\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\", margin: \"-5px -5px 0 15px\", display: props.closeIcon ? \"\" : \"none\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Icon",
      "parent": 102,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Icon-103"
        },
        "name": {
          "type": "code",
          "value": "\"close\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-104"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop:\"10px\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "label": "divgrid",
      "name": "div",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-105"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(6, 1fr)\",\"gridTemplateColumns\":\"repeat(50, 1fr)\"}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "code",
          "value": "`1. ${props.ClinicalTermNursing?.disc_nursing1?.name}`"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-108"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"1/15\",fontWeight: \"bold\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-109"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/3\", gridColumn: \"1/15\",fontWeight: \"bold\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "code",
          "value": "`2. ${props.ClinicalTermNursing?.disc_nursing2?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-110"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"3/4\", gridColumn: \"1/15\",fontWeight: \"bold\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-111"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/5\", gridColumn: \"1/10\",display:\"flex\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Label",
      "parent": 109,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dischargePlanning?.predischarge_condition || '-'"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Label-112"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Checkbox",
      "parent": 111,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[0]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-113"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing2.items.0.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[0]?.name"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-114"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"3/4\", gridColumn: \"17/23\",display:\"flex\"}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Radio",
      "parent": 115,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing1?.has_problem === \"N\""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Radio-116"
        },
        "label": {
          "type": "value",
          "value": "ไม่มี",
          "valueEN": "do not have"
        },
        "name": {
          "type": "value",
          "value": "has_problem"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_nursing1.has_problem\")"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "value": {
          "type": "value",
          "value": "N"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "Radio",
      "parent": 115,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing1?.has_problem === \"Y\""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Radio-117"
        },
        "label": {
          "type": "value",
          "value": "มี",
          "valueEN": "have"
        },
        "name": {
          "type": "value",
          "value": "has_problem"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_nursing1.has_problem\")"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "value": {
          "type": "value",
          "value": "Y"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"1/4\",display:\"flex\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-119"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/5\", gridColumn: \"11/16\",display:\"flex\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-120"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/5\", gridColumn: \"17/25\",display:\"flex\"}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/5\", gridColumn: \"26/35\",display:\"flex\"}"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "ระบุ",
          "valueEN": "specify"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-122"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"5/6\",}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-123"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"7/16\",}"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "Checkbox",
      "parent": 118,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[4]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-124"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing2.items.4.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "Checkbox",
      "parent": 119,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[1]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-125"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing2.items.1.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "Checkbox",
      "parent": 120,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[2]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-126"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing2.items.2.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 127,
      "name": "Checkbox",
      "parent": 121,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[3]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-127"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing2.items.3.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": "อื่น ๆ",
          "valueEN": "other"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-128"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[1]?.name"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-129"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 120,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[2]?.name"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 121,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[3]?.name"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "Input",
      "parent": 123,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Input-132"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_nursing2.items.4.answer\")"
        },
        "type": {
          "type": "value",
          "value": "text"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing2?.items[4]?.answer"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "code",
          "value": "`3. ${props.ClinicalTermNursing?.disc_nursing3?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-133"
        },
        "style": {
          "type": "code",
          "value": "{ height:\"40px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"8/9\", gridColumn: \"2/10\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "Button",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม",
          "valueEN": "increase"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Button-135"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddDiscNursing3"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "code",
          "value": "`4. ${props.ClinicalTermNursing?.disc_nursing4?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"1/18\",fontWeight: \"bold\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 138,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "date"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-137"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", padding: \"5px\" }"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-138"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/3\", gridColumn: \"1/8\", display: \"flex\" }"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 140,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "time"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", padding: \"5px\" }"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-140"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/3\", gridColumn: \"9/15\", display: \"flex\"}"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 144,
      "props": {
        "children": {
          "type": "value",
          "value": "จากหอผู้ป่วย",
          "valueEN": "From the ward"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-141"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", padding: \"5px\" }"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "Label",
      "parent": 138,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dischargePlanning?.ended_date || '-'"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Label-142"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "Label",
      "parent": 140,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dischargePlanning?.ended_time || '-'"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Label-143"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-144"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/3\", gridColumn: \"16/30\", display: \"flex\"}"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Label",
      "parent": 144,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dischargePlanning?.discharged_from || '-'"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Label-145"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "code",
          "value": "`5. ${props.ClinicalTermNursing?.disc_nursing5?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"3/4\", gridColumn: \"1/18\",fontWeight: \"bold\"}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-147"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/8\", gridColumn: \"2/25\"}"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "code",
          "value": "`6. ${props.ClinicalTermNursing?.disc_nursing6?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"9/10\", gridColumn: \"1/18\",fontWeight: \"bold\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-150"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"10/11\", gridColumn: \"1/5\",display:\"flex\"}"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-151"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"10/11\", gridColumn: \"6/11\",display:\"flex\"}"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-152"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"10/11\", gridColumn: \"12/18\",display:\"flex\"}"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-153"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"10/11\", gridColumn: \"19/29\",display:\"flex\"}"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"11/12\", gridColumn: \"1/4\",display:\"flex\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": "ระบุ",
          "valueEN": "specify"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-155"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"11/12\", gridColumn: \"5/6\",display:\"flex\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"11/12\", gridColumn: \"7/18\",display:\"flex\"}"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "Checkbox",
      "parent": 150,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[0]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-157"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing6.items.0.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "Checkbox",
      "parent": 151,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[1]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-158"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing6.items.1.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "Checkbox",
      "parent": 152,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[2]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-159"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing6.items.2.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "Checkbox",
      "parent": 153,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[3]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-160"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing6.items.3.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 161,
      "name": "Checkbox",
      "parent": 154,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[4]?.checked"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Checkbox-161"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCheckValue(\"disc_nursing6.items.4.checked\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\"}"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[0]?.name"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-162"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 151,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[1]?.name"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-163"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[2]?.name"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-164"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "div",
      "parent": 153,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[3]?.name"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-165"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[4]?.name"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-166"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"3px\",marginLeft:\"10px\"}"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "Input",
      "parent": 156,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Input-167"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_nursing6.items.4.answer\")"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing6?.items[4]?.answer"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "code",
          "value": "`7. ${props.ClinicalTermNursing?.disc_nursing7?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-168"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"12/13\", gridColumn: \"1/18\",fontWeight: \"bold\"}"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-169"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"13/14\", gridColumn: \"2/19\"}"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "Label",
      "parent": 169,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dischargePlanning?.discharge_status || '-'"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Label-170"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 134,
      "props": {
        "children": {
          "type": "code",
          "value": "props.discNursing3"
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-171"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "label": "divgrid",
      "name": "div",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-172"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(13, 1fr)\",\"gridTemplateColumns\":\"repeat(50, 1fr)\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-div-173"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "Form",
      "parent": 147,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-Form-175"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 176,
      "name": "FormGroup",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-FormGroup-176"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 177,
      "name": "FormField",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-FormField-177"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "TextArea",
      "parent": 177,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryPlanningUX-TextArea-178"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_nursing5.nextAppointments\")"
        },
        "rows": {
          "type": "code",
          "value": "6"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermNursing?.disc_nursing5?.nextAppointments"
        }
      },
      "seq": 178,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSummaryPlanningUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "drugSearch": "[Drug Search Box]"
  },
  "width": 80
}

*********************************************************************************** */
